import { render, staticRenderFns } from "./ZangyouComponent.vue?vue&type=template&id=4bdb27d7&"
import script from "./ZangyouComponent.vue?vue&type=script&lang=js&"
export * from "./ZangyouComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports